import type { Product } from './product';

export type RoutineItem = {
  step: number;
  stepName: string;
  categorySlug: string;
  currentlyViewing: boolean;
  product: Product | null;
};

export type Routine = {
  name: string;
  items: RoutineItem[];
};
